import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

export default function ProgressBar({ steps, currentStep }) {
  return (
    <div className="mt-8">
      <div className="flex justify-between items-center">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center">
              <div 
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 
                  ${index <= currentStep 
                    ? 'border-cyan-500 bg-cyan-500 text-black' 
                    : 'border-gray-600 bg-gray-800 text-gray-400'
                  }`}
              >
                {index < currentStep ? (
                  <CheckIcon className="w-6 h-6" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <span 
                className={`mt-2 text-sm ${
                  index <= currentStep ? 'text-cyan-500' : 'text-gray-500'
                }`}
              >
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div 
                className={`flex-1 h-0.5 ${
                  index < currentStep ? 'bg-cyan-500' : 'bg-gray-600'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}